class MotoGpClient {
  private baseUrl = `/proxy/motogp/v1`

  public constructor(baseUrl = '') {
    this.baseUrl = `${baseUrl ?? ""}/proxy/motogp/v1`
  }

  async seasons(): Promise<MotoGP.Season[]> {
    return await fetch(`${this.baseUrl}/results/seasons`)
      .then((response) => response.json())
      .catch(() => [])
  }

  async events(seasonId: string): Promise<MotoGP.Event[]> {
    return await fetch(`${this.baseUrl}/results/events?seasonUuid=${seasonId}`)
      .then((response) => response.json())
      .catch(() => [])
  }

  async categories(seasonId: string): Promise<MotoGP.Category[]> {
    return await fetch(`${this.baseUrl}/results/categories?seasonUuid=${seasonId}`)
      .then((response) => response.json())
      .catch(() => [])
  }

  async sessions(eventId: string, categoryId: string): Promise<MotoGP.Session[]> {
    return await fetch(`${this.baseUrl}/results/sessions?eventUuid=${eventId}&categoryUuid=${categoryId}`)
      .then((response) => response.json())
      .catch(() => [])
  }

  async classification(sessionId: string, test: boolean = false): Promise<MotoGP.Result[]> {
    return await fetch(`${this.baseUrl}/results/session/${sessionId}/classification${test ? '?test=true' : ''}`)
      .then<{ classification: MotoGP.Result[] }>((response) => response.json())
      .then((response) => response.classification ?? [])
      .catch(() => [])
  }

  async teams(categoryId: string, year: number): Promise<MotoGP.Team[]> {
    return await fetch(`${this.baseUrl}/teams?categoryUuid=${categoryId}&seasonYear=${year}`)
      .then((response) => response.json())
      .catch(() => [])
  }

  async standings(seasonId: string, categoryId: string): Promise<MotoGP.Standings[]> {
    return await fetch(`${this.baseUrl}/results/standings?seasonUuid=${seasonId}&categoryUuid=${categoryId}`)
      .then<{ classification: MotoGP.Standings[] }>((response) => response.json())
      .then((response) => response.classification ?? [])
      .catch(() => [])
  }
}

const client = new MotoGpClient(import.meta.env.VITE_API_BASE_URL)

export { client }
